import { render, staticRenderFns } from "./BDatePickerStore.vue?vue&type=template&id=520a1b2b&scoped=true"
import script from "./BDatePickerStore.vue?vue&type=script&lang=js"
export * from "./BDatePickerStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520a1b2b",
  null
  
)

export default component.exports